// extracted by mini-css-extract-plugin
export var body = "_1x-8";
export var button = "_1x-0";
export var closeButton = "_1x-5";
export var content = "_1x-3";
export var empty = "_1x-f";
export var grid = "_1x-c";
export var header = "_1x-4";
export var icon = "_1x-1";
export var option = "_1x-d";
export var optionSelected = "_1x-e";
export var overlay = "_1x-2";
export var searchIcon = "_1x-a";
export var searchInput = "_1x-b";
export var searchWrapper = "_1x-9";
export var title = "_1x-6";
export var visuallyHidden = "_1x-7";